// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"92":"7cfa3b7b","594":"58c56a5c"}[chunkId] + ".css";
};